import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { fetchStores, addStore } from "./StoreApi";


export function useStores() {
    return useQuery(
        {
            queryKey: ['stores'],
            queryFn: fetchStores,
        }
    )
}


export function useAddStore() {
    const queryClient = useQueryClient();
    return useMutation(
        {
            mutationFn: addStore,
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: ['stores']
                })
            }
        }
    );
}

